import React, { useEffect } from 'react'
import { Text, Title, Box, Skeleton, Grid, Card, Button, Table, Flex, Badge, Group, ActionIcon } from '@mantine/core'
import { DatePickerInput } from '@mantine/dates';
import { currencyFormat } from 'simple-currency-format';
import { HiSearch, HiOutlineCalendar, HiOutlineTrendingUp, HiOutlineReceiptTax, HiOutlineLibrary } from 'react-icons/hi'

import RecordRow from '../components/Records/RecordRow';
import { useRecordStore } from '../store/useRecordStore';
import { StatsCard } from '../components/common/Stats';

const Records = () =>
{
  const {
    items,
    startDate,
    endDate,
    total,
    totalAmount,
    momStats,
    loading,
    initialize,
    setStartDate,
    setEndDate,
    onSearch
  } = useRecordStore();

  useEffect(() =>
  {
    initialize();
  }, [ initialize ]);

  const avgTicket = total > 0 ? totalAmount / total : 0;

  return (
    <Box className='w-full gap-1 overflow-x-auto py-2 px-2'>
      <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" align={{ base: 'flex-start', md: 'center' }} mb="xl" gap="md">
        <Box>
          <Title order={ 1 } c="dark.5">Registro de Ingresos</Title>
          <Text c="dimmed" size="sm" fw={500}>Gestión y conciliación de pagos recibidos</Text>
        </Box>
        
        <Card withBorder radius="lg" p="md" shadow="sm" className="bg-slate-50">
          <Group align="flex-end" gap="xs">
            <Box w={140}>
              <Text size='xs' fw={800} mb={4} c="dimmed" className="tracking-widest uppercase">Desde</Text>
              <DatePickerInput 
                leftSection={ <HiOutlineCalendar className="text-yellow-600" /> } 
                variant='filled' 
                size="sm" 
                radius="md" 
                value={ startDate } 
                valueFormat="DD/MM/YYYY" 
                onChange={ setStartDate } 
              />
            </Box>
            <Box w={140}>
              <Text size='xs' fw={800} mb={4} c="dimmed" className="tracking-widest uppercase">Hasta</Text>
              <DatePickerInput 
                leftSection={ <HiOutlineCalendar className="text-yellow-600" /> } 
                variant='filled' 
                size="sm" 
                radius="md" 
                value={ endDate } 
                valueFormat="DD/MM/YYYY" 
                onChange={ setEndDate } 
              />
            </Box>
            <Button
              leftSection={ <HiSearch /> }
              size="sm" 
              onClick={ onSearch }
              loading={loading}
              h={36}
            >
              Buscar
            </Button>
          </Group>
        </Card>
      </Flex>

      <Grid mb="xl">
        <Grid.Col span={{ base: 12, md: 4 }}>
          <StatsCard 
            title="Total Recaudado" 
            value={totalAmount} 
            icon={<HiOutlineTrendingUp size={24} />}
            color="yellow"
            currency={true}
            description="Monto bruto del periodo"
            diff={momStats?.revenue?.diff || 0}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <StatsCard 
            title="Transacciones" 
            value={total} 
            icon={<HiOutlineReceiptTax size={24} />}
            color="gray"
            description="Pagos registrados con éxito"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <StatsCard 
            title="Ticket Promedio" 
            value={avgTicket} 
            icon={<HiOutlineLibrary size={24} />}
            color="dark"
            currency={true}
            description="Promedio por operación"
          />
        </Grid.Col>
      </Grid>
...

      <Card shadow="md" p={0} radius="lg" withBorder className='w-full overflow-hidden'>
        <Table.ScrollContainer minWidth={ 800 }>
          <Table verticalSpacing="sm" highlightOnHover>
            <Table.Thead bg="gray.0">
              <Table.Tr>
                <Table.Th px="md" py="md"><Text size="xs" fw={800} c="dimmed" className="tracking-tighter">BANCO / ENTIDAD</Text></Table.Th>
                <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-tighter">FECHA VALOR</Text></Table.Th>
                <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-tighter">CUENTA</Text></Table.Th>
                <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-tighter">MONTO OPERADO</Text></Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {!loading && items ? (
                items.length > 0 ? (
                  items.map(item => <RecordRow key={item._id} item={item} />)
                ) : (
                  <Table.Tr>
                    <Table.Td colSpan={5} align="center" py="xl">
                      <Text c="dimmed" size="sm">No se encontraron registros en este periodo.</Text>
                    </Table.Td>
                  </Table.Tr>
                )
              ) : (
                Array(5).fill(0).map((_, i) => (
                  <Table.Tr key={i}>
                    <Table.Td colSpan={5} p="xs">
                      <Skeleton height={40} radius="md" />
                    </Table.Td>
                  </Table.Tr>
                ))
              )}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Card>
    </Box>
  )
}

export default Records
